import type {
  BookingUpdateRequestCreateApiData,
  BookingUpdateRequestCreateApiResponses,
  BookingUpdateRequestDeleteApiData,
  BookingUpdateRequestDeleteApiResponses,
  BookingUpdateRequestGetApiData,
  BookingUpdateRequestGetApiResponses,
  BookingUpdateRequestListApiData,
  BookingUpdateRequestListApiResponses,
  BookingUpdateRequestPatchApiData,
  BookingUpdateRequestPatchApiResponses,
  BookingUpdateRequestSendApiData,
  BookingUpdateRequestSendApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getBookingUpdateRequestUrls = {
  deleteBookingUpdateRequest: dataEndpoint<BookingUpdateRequestDeleteApiData, BookingUpdateRequestDeleteApiResponses>({
    getUrl: ({ bookingUpdateRequestId }) => apiUrl(`booking-update-requests/${bookingUpdateRequestId}/`)
  }),
  getPaginatedBookingUpdateRequests: dataEndpoint<
    BookingUpdateRequestListApiData,
    BookingUpdateRequestListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('booking-update-requests/', queryParams)
  }),
  getBookingUpdateRequest: dataEndpoint<BookingUpdateRequestGetApiData, BookingUpdateRequestGetApiResponses>({
    getUrl: ({ bookingUpdateRequestId }) => apiUrl(`booking-update-requests/${bookingUpdateRequestId}/`)
  }),
  patchBookingUpdateRequest: responseEndpoint<BookingUpdateRequestPatchApiData, BookingUpdateRequestPatchApiResponses>({
    getUrl: ({ bookingUpdateRequestId }) => apiUrl(`booking-update-requests/${bookingUpdateRequestId}/`),
    getBody: ({ bookingUpdateRequestId: _, ...body }) => body
  }),
  postBookingUpdateRequest: responseEndpoint<BookingUpdateRequestCreateApiData, BookingUpdateRequestCreateApiResponses>(
    {
      getUrl: () => apiUrl('booking-update-requests/'),
      getBody: (data) => data
    }
  ),
  postBookingUpdateRequestSend: responseEndpoint<BookingUpdateRequestSendApiData, BookingUpdateRequestSendApiResponses>(
    {
      getUrl: ({ bookingUpdateRequestId }) => apiUrl(`booking-update-requests/${bookingUpdateRequestId}/send/`)
    }
  )
};
